export default __webpack_public_path__ + "static/media/google-cloud-registry.93e06029.svg";